import { ManuteRequestConfig } from '@/api/types';
import { OptionRequest, RequestQueryParams } from '@/api/requests/types';

const BASE_URL = '/users/me/preferences';

/**
 * Request to fetch list of user preferences.
 *
 * @param params
 * @constructor
 */
export const ALL = (params?: RequestQueryParams): ManuteRequestConfig => ({
    method: 'GET',
    url: BASE_URL,
    params,
});

/**
 * Request to find a preference by key.
 *
 * @param key
 */
export const FIND = (key: string): ManuteRequestConfig => ({
    method: 'GET',
    url: `${BASE_URL}/${key}`,
});

/**
 * Request to set a user preference.
 *
 * @param preference
 */
export const SAVE = (preference: OptionRequest): ManuteRequestConfig => ({
    method: 'POST',
    url: BASE_URL,
    data: preference,
});

/**
 * Request to delete a user preference.
 * @param key
 */
export const DELETE = (key: string): ManuteRequestConfig => ({
    method: 'DELETE',
    url: `${BASE_URL}/${key}`,
});
